export default __webpack_public_path__ + "static/media/glass_d.b2a2a4b4.svg";